<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >ENDEREÇOS RETIRADA</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>

    <v-card v-show="!sv">
      <v-row no-gutters>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            filled
            dense
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="text-left" cols="4">
          <v-btn @click="novo()" color="topEnviados" dark>
            <v-icon>mdi-plus</v-icon>Novo
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="itemsCategoria"
        :loading="loading_table"
        :footerProps="footerProps"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-2"
      >
        <!--<template class="text-right" v-slot:item.chk_ativo="{ item }">
          <v-switch
            class="text-rigth"
            color="botao_sucesso"
            :label="`${checkStatus(item.chk_ativo)}`"
            @change="mudarStatus(item.id, item.chk_ativo)"
            v-model="item.chk_ativo == 1 ? true : false"
            value="item.chk_ativo"
          ></v-switch>
        </template>-->
        <template v-slot:item.action="{ item }">
          <v-icon class="mr-2" color="error" @click="excluirEnd(item)"
            >delete</v-icon
          >
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogCancel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Cancelamento</v-card-title>
          <v-card-text>Deseja excluir essa endereço?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancel = false"
              >Não</v-btn
            >
            <v-btn
              color="green darken-1"
              class="white--text"
              @click="deleta(selItem)"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="dialogCadastro" persistent max-width="50%">
      <v-card>
        <v-card-title class>Cadastro Endereço</v-card-title>
        <v-card-text>
          <v-container>
            <v-row no-gutters>
              <v-col cols="4">
                <v-text-field
                  v-model="endereco.cep"
                  append-icon="search"
                  label="CEP"
                  v-mask="'########'"
                  filled
                  counter="8"
                  dense
                  :loading="carregaCep"
                  single-line
                ></v-text-field>
              </v-col>
              <v-col cols="4" md="4" lg="4">
                <v-text-field
                  v-model="endereco.bairro"
                  label="Bairro"
                  filled
                  disabled
                  dense
                  single-line
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" md="4" lg="4">
                <v-text-field
                  v-model="endereco.numero"
                  label="Nº"
                  filled
                  dense
                  single-line
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" md="4" lg="4">
                <v-text-field
                  v-model="endereco.ponto_referencia"
                  label="Ponto de Referência"
                  filled
                  dense
                  single-line
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="6" lg="6">
                <v-text-field
                  v-model="endereco.logradouro"
                  label="Endereço"
                  filled
                  disabled
                  dense
                  single-line
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" md="4" lg="4">
                <v-text-field
                  v-model="endereco.municipio"
                  label="Cidade"
                  filled
                  disabled
                  dense
                  single-line
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="2" md="2" lg="2">
                <v-text-field
                  v-model="endereco.uf"
                  label="UF"
                  filled
                  disabled
                  dense
                  single-line
                  clearable
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogCadastro = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="success" @click="gravar()" class="mr-4">
              <v-icon>mdi-check</v-icon>Gravar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :timeout="tempo"
      :color="error"
      :multi-line="multiline"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      {{ textSnack }}
      <v-btn @click.native="snackbar = false">Fechar</v-btn>
    </v-snackbar>
    <v-snackbar
      :timeout="5000"
      :color="sucesso"
      :top="true"
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarSuccess"
    >
      {{ textSucesso }}
      <v-btn @click.native="snackbarSuccess = false">Fechar</v-btn>
    </v-snackbar>
  </v-content>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    source: String,
  },
  data: () => ({
    singleLine: true,
    footerProps: { "items-per-page-options": [30, 50, 100] },
    categoria: {
      descricao: "",
    },
    botao_sucesso: "botao_sucesso",
    money: {
      decimal: ",",
      thousands: ".",
      precision: 2,
      masked: false /* doesn't work with directive */,
    },
    error: "error",
    tempo: 5000,
    mode: "vertical",
    snackbar: false,
    textSnack: "",
    multiline: true,
    sucesso: "botao_sucesso",
    snackbarSuccess: false,

    textSucesso: "",

    sheet: false,

    itemsUnidade: ["UN", "PC", "KG"],

    filtroProduto: "Produtos ",
    sv: false,
    carregaCep: false,
    dialogCadastro: false,
    itensPorPagina: 25,
    itemsCategoria: [],
    itemsProdutosSgt: [],
    itemsProdutosSgtVinculados: [],
    search: "",
    searchVinculados: "",
    loading_table: false,
    selProduto: "",
    itemEdit: "",
    dialogCancel: false,
    selItem: "",
    endereco: {
      bairro: "",
      logradouro: "",
      municipio: "",
      cep: "",
      numero: "",
      ponto_referencia: "",
    },

    headers: [
      {
        text: "Endereço",
        align: "left",
        sortable: true,
        value: "logradouro",
      },
      {
        text: "Numero",
        align: "left",
        sortable: true,
        value: "numero",
      },
      {
        text: "Bairro",
        align: "left",
        sortable: true,
        value: "bairro",
      },
      { text: "Ação", value: "action", sortable: false },
    ],
  }),
  watch: {
    "endereco.cep"(val) {
      if (this.endereco.cep.length == 8) {
        this.carregaCep = true;
        this.buscaCep(val);
        ///this.mensagem.tipo.splice(a, 1);
        event.preventDefault();
      }
    },
    sv(val) {
      if (val === true) {
        this.filtroProduto = "Produtos vinculados";
        this.buscaProdutosSgtVinc();
      } else {
        this.filtroProduto = "Produtos sem Vinculo";
      }
    },
  },
  mounted() {
    //this.buscaProdutos();

    this.buscaEnderecos();
  },
  methods: {
    checkStatus(valor) {
      if (valor == 1) {
        return "Ativo";
      } else {
        return "Inativo ";
      }
    },
    buscaCep(cep) {
      this.$viaCep.buscarCep(cep).then((obj) => {
        if (obj.erro) {
          this.cep = "";
          this.textSnack = "Cep não existe!";
          this.snackbar = true;

          this.carregaCep = false;
        } else {
          this.carregaCep = false;
          this.endereco.municipio = obj.localidade;
          this.endereco.logradouro = obj.logradouro;
          this.endereco.uf = obj.uf;
          this.endereco.bairro = obj.bairro;
        }
      });
    },
    limpaCampos() {
      this.endereco.municipio = "";
      this.endereco.logradouro = "";
      this.endereco.uf = "";
      this.endereco.bairro = "";
      this.endereco.ponto_referencia = "";
      this.cep = "";
      this.endereco.cep = "";
      this.endereco.numero = "";
    },
    novo() {
      this.dialogCadastro = true;
      this.limpaCampos();
    },
    excluirEnd(item) {
      this.selItem = item.id;
      this.dialogCancel = true;
    },
    deleta() {
      axios
        .post(`/config/end_retirada/delete`, { id: this.selItem })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Endereço excluido com sucesso!";
            this.buscaEnderecos();
            this.itemEdit = "";
            this.dialogCancel = false;
            this.selProduto = "";
          }
        });
    },
    editProduto(item) {
      this.dialog = true;
      this.itemEdit = item.id;
    },
    buscaEnderecos() {
      this.loading_table = true;
      axios.get(`/config/end_retirada`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          this.itemsCategoria = response.data;
        }
      });
    },
    gravar() {
      axios
        .post(`/config/end_retirada`, this.endereco)
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Endereço incluido com sucesso!";
            this.buscaEnderecos();
            this.itemEdit = "";
            this.selProduto = "";
            this.limpaCampos();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 0px !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.v-data-table td {
  font-size: 0.685rem !important;
}

.v-messages {
  min-height: 0px !important;
}
</style>
